import { actionCopyDa } from "./actionCopy";
import { listCopyDa } from "./listCopy";

export const templatesCopyDa = {
    templates: "Skabeloner",
    navDescription: "Gennemse skabeloner og inviter patienter til at spore resultater.",
    myTemplatesTitle: "Mine skabeloner",
    myTemplatesDescription:
        "Opret og administrer skabeloner for hurtigt at invitere patienter til at spore resultater. Klik på en række for at bruge en skabelon, eller åbn menuen for flere handlinger.",
    myTemplatesAria: "Mine skabeloner",
    publicTemplatesTitle: "Offentlige skabeloner",
    breadcrumbNew: "Ny",
    selectAtLeastOneTemplate: "Vælg mindst én skabelon",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Tilføj skabelon til min konto" : `Tilføj ${count} skabeloner til min konto`,
    creatingTemplates: "Opretter skabeloner…",
    publicTemplatesDescription:
        "Gennemse færdige opsætninger og tilføj dem til din konto, eller lav din egen. Vælg en skabelon for hurtigt at komme i gang.",
    browsePublic: "Gennemse offentlige",
    browsePublicAria: "Gennemse offentlige skabeloner",
    newTemplate: "Ny skabelon",
    newTemplateAria: "Ny skabelon",
    makeMyOwn: "Lav min egen",
    favourites: "Favoritter",
    noQuestionnaires: "Ingen spørgeskemaer",
    moreQuestionnaires: (count: number) => `+${count} flere`,
    useTemplate: "Brug skabelon",
    newDiary: "Ny dagbog",
    searchPlaceholder: "Søg efter skabeloner...",
    searchAria: "Søg skabeloner",
    clearSearchAria: actionCopyDa.clearSearch,
    filters: actionCopyDa.filters,
    clearAll: actionCopyDa.clearAll,
    procedureFilterPrefix: "Behandling:",
    statusFilterPrefix: "Status:",
    substanceFilterPrefix: "Substans:",
    subsiteFilterPrefix: "Delområde:",
    siteFilterPrefix: "Lokalisation:",
    typeFilterPrefix: "Type:",
    areaFilterPrefix: "Område:",
    consultationFilterPrefix: "Konsultation:",
    removeProcedureFilterAria: (label: string) => `Fjern behandlingsfilter ${label}`,
    removeStatusFilterAria: (label: string) => `Fjern statusfilter ${label}`,
    removeOwnerFilterAria: (name: string) => `Fjern ejerfilter ${name}`,
    removePeopleFilterAria: (name: string) => `Fjern personfilter ${name}`,
    removeSubstanceFilterAria: "Fjern substansfilter",
    removeSubsiteFilterAria: "Fjern delområdefilter",
    removeSiteFilterAria: "Fjern lokalisationsfilter",
    removeShockwaveTypeFilterAria: "Fjern filter for stødbehandlingstype",
    removeAreaFilterAria: "Fjern områdefilter",
    removeConsultationFilterAria: "Fjern konsultationsfilter",
    ownerFilterLabel: "Ejer (kliniker eller sekretær)",
    ownerFilterPlaceholder: "Alle brugere",
    statusFilterLabel: "Status",
    statusFilterPlaceholder: "Alle statusser",
    peopleOnTemplateLabel: "Personer på skabelon",
    peopleOnTemplatePlaceholder: "Enhver på skabelon",
    procedureTypeLabel: "Behandlingstype",
    procedureTypePlaceholder: "Enhver behandlingstype",
    areaLabel: "Område",
    substanceLabel: "Substans",
    subsiteLabel: "Delområde",
    typeLabel: "Type",
    siteLabel: "Lokalisation",
    consultationLabel: "Konsultation",
    selectPlaceholder: "Vælg...",
    clearFilterAria: (label: string) => `Ryd ${label}`,
    injection: "Injektion",
    shockwave: "Stødbehandling",
    surgery: "Operation",
    consultation: "Konsultation",
    medication: "Medicin",
    product: "Produkt",
    published: listCopyDa.published,
    draft: listCopyDa.draft,
    noTemplatesYet: "Ingen skabeloner endnu",
    noMatchingTemplates: "Ingen matchende skabeloner",
    noTemplatesYetHint: "Opret din første skabelon for hurtigt at invitere patienter.",
    noMatchingHint: "Prøv at justere din søgning eller filtre.",
    createFirstTemplate: "Opret din første skabelon",
    emptyTemplatesHelpLink: "Hvordan laver jeg en skabelon?",
    tableHint:
        "Klik på en række for at invitere en patient fra den pågældende skabelon. Brug ikonerne på hver række, eller åbn menuen for de samme handlinger og mere.",
    forms: "Formularer",
    lastEdited: "Sidst redigeret",
    procedure: "Behandling",
    area: "Område",
    people: "Personer",
    details: "Detaljer",
    actions: listCopyDa.actions,
    select: "Vælg",
    useTemplateAria: "Ny dagbog",
    editTemplateAria: "Rediger skabelon",
    tapToUseTemplate: "Tryk for at bruge denne skabelon",
    useThisTemplateAria: "Brug denne skabelon",
    clickRowToUseAria: "Klik på rækken for at bruge denne skabelon",
    publicTemplatesTableAria: "Offentlige skabeloner",
    yourTemplatesTableAria:
        "Dine skabeloner; vælg en række for at bruge den pågældende skabelon, eller brug handlinger på hver række",
    noTemplatesInView: "Ingen skabeloner i denne visning.",
    showingTemplatesRange: (start: number, end: number, total: number) =>
        `Viser skabeloner ${start} til ${end} af ${total}`,
    previous: actionCopyDa.previous,
    next: actionCopyDa.next,
    save: actionCopyDa.save,
    rename: actionCopyDa.rename,
    editTemplate: "Rediger skabelon",
    addToFavourites: "Tilføj til favoritter",
    removeFromFavourites: "Fjern fra favoritter",
    copyUrl: "Kopiér URL",
    shareTemplate: "Del skabelon",
    labelsAndDiaryType: "Etiketter og dagbogstype",
    publishTemplate: "Udgiv skabelon",
    linkToMasterTemplate: "Knyt til masterskabelon",
    duplicate: actionCopyDa.duplicate,
    delete: actionCopyDa.delete,
    deleteTemplateTitle: "Slet skabelon",
    deleteTemplateDescription: "Er du sikker på, at du vil slette denne skabelon? Denne handling kan ikke fortrydes.",
    cancel: actionCopyDa.cancel,
    templateUpdatedToast: "Skabelon opdateret",
    copiedToClipboardToast: "Kopieret til udklipsholder",
    unnamedTemplate: "Unavngivet skabelon",
    questionnaireSchedule: "Spørgeskemaplan",
    interventionStep: "Behandling",
    injectionDetails: "Injektionsdetaljer",
    surgeryClinicians: "Operationsbehandlere",
    surgeryDetails: "Operationsdetaljer",
    shockwaveClinicians: "Stødbehandlere",
    shockwaveDetails: "Stødbehandlingsdetaljer",
    noIntervention: "Ingen behandling",
    dateStep: "Dato",
    dateQuestion: "Hvilken dato tælles opfølgningerne fra?",
    dateDiaryStart: "Fra den dag dagbogen oprettes",
    dateDiaryStartHint: "Spørgeskemaerne starter med det samme. Patienten bliver ikke spurgt om en dato.",
    dateAskPatient: "Lad den stå tom - patienten fortæller os det",
    dateAskPatientHint: "Patienten angiver datoen, når de opretter deres dagbog. Du kan også tilføje den senere.",
    saveTemplate: "Gem skabelon",
    lockLabel: "Lås",
    unlockLabel: "Lås op",
    lockedLabel: "Låst",
    lockedByTemplateCreator: "Låst af skabelonens opretter",
    usageInstructionsPlaceholder: "f.eks. Bruges 2 timer dagligt, rengøres efter brug",
    productNameRequired: "Produktnavn er påkrævet",
    contactEmail: "Kontakt-e-mail",
    selectContactPlaceholder: "Vælg kontakt-e-mail",
    defaultContactForOrganisation: (organisationNames: string) => `Standard for ${organisationNames}`,
    templateCreatedTitle: "Skabelonen blev oprettet!",
    templateCreatedMessage: "Sparet tid er vundet tid!",
    templateNotFoundTitle: "Skabelonen blev ikke fundet",
    templateNotFoundDescription: "Skabelonen kunne ikke findes. Prøv igen.",
    backToTemplates: "Tilbage til skabeloner",
    userFallback: (idPrefix: string) => `Bruger ${idPrefix}...`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Injektion",
            shockwave: "Stødbehandling",
            surgery: "Operation",
            education: "Konsultation",
            medication: "Medicin",
            product: "Produkt",
        };
        return map[type] ?? type;
    },
    statusLabel: (status: "published" | "draft") => (status === "published" ? "Udgivet" : "Kladde"),
};
